import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 4,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'key', type: 'string' }]
    })
  ]
}
